import { useEffect, useState } from 'react'
import type { HostTreeNode } from '../api/inventoree'

/**
 * Tree View din od_ux.js OdHostTree: randuri indentate, chevron, iconita,
 * numele ca legatura, tipul gazdei. Gol: "No hosts in this list."
 */

export function HostTreeView({ roots, loading, error, deviceUrl }: { roots: HostTreeNode[]; loading: boolean; error: string | null; deviceUrl?: string }) {
  if (loading) {
    return (
      <div className="od-host-tree">
        <div className="od-host-tree-empty">Loading...</div>
      </div>
    )
  }
  if (error) {
    return (
      <div className="od-host-tree">
        <div className="od-host-tree-empty">The tree could not be loaded.</div>
      </div>
    )
  }
  if (roots.length === 0) {
    return (
      <div className="od-host-tree">
        <div className="od-host-tree-empty">No hosts in this list.</div>
      </div>
    )
  }

  return (
    <div className="od-host-tree">
      {roots.map((node) => (
        <HostNode key={node.id} node={node} depth={0} deviceUrl={deviceUrl} />
      ))}
    </div>
  )
}

function HostNode({ node, depth, deviceUrl }: { node: HostTreeNode; depth: number; deviceUrl?: string }) {
  const kids = node.guests ?? []
  const [open, setOpen] = useState(true)
  const href = (deviceUrl ?? '/inventoree/device/') + node.id

  return (
    <div className="od-host-tree-node">
      <div className="od-host-tree-row" style={{ paddingLeft: depth * 22 }}>
        {kids.length > 0 ? (
          <button type="button" className="od-host-tree-twist" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
            <i className={`fas ${open ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
          </button>
        ) : (
          <span className="od-host-tree-twist is-leaf"></span>
        )}
        <span className="od-host-tree-icon" dangerouslySetInnerHTML={{ __html: node.icon || '' }}></span>
        <a className="od-host-tree-name" href={href}>
          {node.name}
        </a>
        {node.host_type_label ? <span className="od-host-tree-type">{node.host_type_label}</span> : null}
      </div>
      {kids.length > 0 && open ? (
        <div className="od-host-tree-kids">
          {kids.map((child) => (
            <HostNode key={child.id} node={child} depth={depth + 1} deviceUrl={deviceUrl} />
          ))}
        </div>
      ) : null}
    </div>
  )
}

/** body.od-host-tree-mode - foaia list_chrome.css ascunde footer-ul listei. */
export function useHostTreeMode(on: boolean) {
  useEffect(() => {
    if (!on) return
    document.body.classList.add('od-host-tree-mode')
    return () => document.body.classList.remove('od-host-tree-mode')
  }, [on])
}
